import {createSelector} from 'reselect';

const selectGlobal = state => state.get('global');

const makeSelectUser = () => createSelector(
    selectGlobal,
    global => global.user
);

const makeSelectPageLimit = () => createSelector(
    selectGlobal,
    global => global.limit
);

const makeSelectErrorMessage = () => createSelector(
    selectGlobal,
    global => global.errorMessage
);

const makeSelectOverflowAdd = () => createSelector(
    selectGlobal,
    global => global.addOverflow
);

const makeSelectOverflowRemove = () => createSelector(
    selectGlobal,
    global => global.removeOverflow
);
const makeSelectOverflowToggle = () => createSelector(
    selectGlobal,
    global => global.toggleOverflow
);

const makeSelectTitle = () => createSelector(
    selectGlobal,
    global => global.title
);

const makeSelectUserLoading = () => createSelector(
    selectGlobal,
    global => global.loading
);

export {
    makeSelectUser,
    makeSelectPageLimit,
    makeSelectErrorMessage,
    makeSelectOverflowAdd,
    makeSelectOverflowRemove,
    makeSelectOverflowToggle,
    makeSelectTitle,
    makeSelectUserLoading
};
